import http from "./httpService";
import { apiUrl } from "../config.json";

const apiEndpoint = apiUrl + "/aircraftmodels";

function modelUrl(id) {
  return `${apiEndpoint}/${id}`;
}

//   export function getModels() {
//     return http.get(apiEndpoint);
//   }

export function getModels(aircraft_id) {
  let url = modelUrl(aircraft_id);

  return http.get(url);
}

export function getModelKitsCount() {
  return http.get(modelUrl("kits"));
}

export function getKitMolds() {
  return http.get(modelUrl("kit_molds/list"));
}

export function saveModel(model) {
  console.info(model);
  if (model.model_id) {
    const body = { ...model };
    delete body.model_id;
    return http.put(modelUrl(model.model_id), body);
  }

  return http.post(apiEndpoint, model);
}

export function deleteModel(modelId) {
  return http.delete(modelUrl(modelId));
}
